const contentful = require('contentful')

const client = contentful.createClient({
    space: '1qdbaojjjxn8',
    accessToken: '9Ia110jd9MZqPTZ0-pimGHj9RDFbGt4JVoZylXudUH4'
  })

  export default  client;